import React from 'react'
import { ChevronDown } from 'lucide-react'
import { Button } from '@/components/ui/button'
import Checkbox from '../../checkbox'
import store from '../../../state/store'
import EditCommissionManager from '../commission/edit'

class HandoverButton extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      send_mail: false,
      commission_manager_id: this.props.enquiry_manager_id
    }
  }

  onProceed = () => {
    store.emit('enquiry:handover', this.props.enquiry_id, {
      send_mail: this.state.send_mail,
      commission_manager_id: this.state.commission_manager_id
    })
  }

  onCancel = () => {
    store.emit("ui:enquiry:buttons:support_handover", {open: false})
  }

  onEdit = () => {
    store.emit("ui:enquiry:buttons:support_handover", {open: true})
  }

  onSendMailChange = (params) => {
    this.setState({send_mail: params.checked})
  }

  onCommissionManagerChanger = (commission_manager_id) => {
    this.setState({commission_manager_id: commission_manager_id})
  }

  render() {
    if (this.props.ui.open)
      return (
        <div className="grid gap-4">
          <div className="grid gap-1 text-sm text-muted-foreground">
            <p>Note any lesson orders that haven't been paid for / provisioned will have their products set up on the customer's profile at time of handover.</p>
            <p>Any applied or proposed tutors that haven't been accepted will be rejected.</p>
            <p>Any unpaid Coachbit orders will block handover. Payment must be confirmed first.</p>
          </div>
          <Checkbox name='Send Customer Email' value="send_mail" checked={this.state.send_mail} onChange={this.onSendMailChange}/>
          <div className="flex flex-wrap items-center gap-4">
            <div className="w-full sm:w-1/3">
              <EditCommissionManager
                claim_managers={this.props.claim_managers}
                commission_manager_id={this.state.commission_manager_id}
                onChange={this.onCommissionManagerChanger}
              />
            </div>
            <div className="ml-auto flex justify-end gap-2">
              <Button variant="outline" size="sm" onClick={this.onCancel}>Cancel</Button>
              <Button variant="success" size="sm" onClick={this.onProceed}>Hand Over</Button>
            </div>
          </div>
        </div>
      )
    else
      return (
        <Button size="lg" onClick={this.onEdit}>
          Send To Support <ChevronDown className="size-4"/>
        </Button>
      )
  }
}

export default HandoverButton
